module.exports = __webpack_public_path__ + "img/title.11001bc2.png";